import { render, staticRenderFns } from "./visitRecordEditor.vue?vue&type=template&id=b1a02492&"
import script from "./visitRecordEditor.vue?vue&type=script&lang=js&"
export * from "./visitRecordEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a02492')) {
      api.createRecord('b1a02492', component.options)
    } else {
      api.reload('b1a02492', component.options)
    }
    module.hot.accept("./visitRecordEditor.vue?vue&type=template&id=b1a02492&", function () {
      api.rerender('b1a02492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/visitRecordEditor.vue"
export default component.exports